<template>
	<div class="form-group group-radio-colors">
		<label :for="name">{{ placeholder }}</label>
		<div class="items">
			<label v-for="option in options" :key="option.value" class="item">
				<input type="radio" :name="name" :id="option.text" :value="option.value" v-model="selected" @change="onChange" v-validate="rules" :data-vv-as="placeholder">
				<span class="square" :class="cssClass(option.value)"></span>
			</label>
		</div>
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
import clamp from '@/utils/clamp'
export default {
	inject: ['$validator'],
	props: [
		'value',
		'name',
		'placeholder',
		'rules'
	],
	data () {
		return {
			selected: ''
		}
	},
	watch: {
		value () {
			this.selected = this.value
		}
	},
	computed: {
		result () {
			return this.selected ? this.selected : 0
		},
		options () {
			const result = []
			// there are 16 colors
			for (let i = 0; i < 16; i++) {
				result.push({ value: i, text: i })
			}
			return result
		}
	},
	methods: {
		numToColor (n) {
			n = clamp(n, 0, this.options.length - 1)
			return this.options[n].text
		},
		cssClass (option) {
			let classes = []
			classes.push(`color-${this.numToColor(option)}`)
			if (option === parseInt(this.selected)) classes.push('selected')
			return classes.join(' ')
		},
		onChange () {
			this.$emit('input', this.result)
		}
	},
	created () {
		this.$nextTick(function () {
			this.options.forEach(element => {
				if (element.value === parseInt(this.value)) {
					this.selected = element.value
				}
			})
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/pillboxV2/InputColor.vue